if (window.innerWidth > 991) {
  const observerGallery = new MutationObserver(function (mutations, me) {
    const targetElement = document.querySelector('.cevoid-grid');
    if (targetElement) {
      me.disconnect();
      const isRTL = document.documentElement.dir === 'rtl';
      if (isRTL) {
        if (!targetElement.classList.contains('slick-initialized')) {
          setTimeout(() => {
            $(targetElement).slick({
              dots: false,
              arrows: true,
              infinite: true,
              autoplay: false,
              draggable: true,
              speed: 300,
              slidesToShow: 4,
              centerMode: true,
              centerPadding: '60px',
              rtl: isRTL
            });
            $(targetElement).slick('slickGoTo', 1);
          }, 500);
        }
      } else {
        let index = 0;
        let currTransl = [];
        let translationComplete = true;
        let moveOffset = 0;
        const slider = document.querySelector('.cevoid-grid');
        const sliderItems = document.querySelectorAll('.sc-idOiZg');
        let isDragging = false,
          startPos = 0,
          currentPos = 0;

        let amount = sliderItems.length;
        moveOffset = document.querySelector('.sc-idOiZg').offsetWidth;
        slider.style.width = amount * moveOffset + 'px';

        const transitionCompleted = function () {
          translationComplete = true;
        };

        sliderItems.forEach((item, i) => {
          item.classList.add('animate');
          currTransl[i] = -moveOffset;
          item.addEventListener('transitionend', transitionCompleted, true);
        });

        // adding draggable functionality
        // 1. initialization the process of dragging the slider
        function dragStart(e) {
          isDragging = true;
          startPos = e.clientX; // Saving the initial position of the cursor along the X axis
          currentPos = startPos; // Ensure currentPos starts the same as startPos
        }

        // 2. Executed during the movement
        function dragMove(e) {
          if (!isDragging) return;
          currentPos = e.clientX; // Updating the initial position of the cursor along the X axis
        }

        // 3. Performs the transition logic between slides after the drag is complete
        function dragEnd() {
          if (!isDragging) return;
          isDragging = false;

          let movedBy = startPos - currentPos; // Calculating how far the user has moved the mouse.
          // Prevent sliding if the user hasn't moved enough (e.g., less than 10 pixels)
          if (Math.abs(movedBy) < 10) {
            return; // Treat it as a click, not a drag
          }

          // Check all links inside tags
          const tagsLinks = document.querySelectorAll('.cevoid-tag a');
          let linkClicked = false;

          tagsLinks.forEach(function (tag) {
            const parentElement = tag.closest('.sc-iBPTik');

            tag.addEventListener('click', function (e) {
              // If opacity is not equal to 1, block the click
              if (
                parentElement &&
                window.getComputedStyle(parentElement).opacity !== '1'
              ) {
                e.preventDefault();
                e.stopPropagation();
                linkClicked = true; // We denote that a click on the link was made
              }
            });
          });

          // If there was no click on the link and the movement exceeds 50 pixels, call next or prev
          if (!linkClicked && Math.abs(movedBy) > 50 && translationComplete) {
            movedBy > 0 ? next() : prev(); // Decide direction of slide transition
          }
        }

        // next-prev algo
        // 1. Check if the previous move is completed to avoid overlapping animations (translationComplete)
        // 2. Update the index for the previous/next slide and adjust it to stay within the range
        // 3. Determine the index of the outer slide that will be hidden or moved offscreen
        // 4. Loop through all slides and update their position and visibility
        // 5. Update position and visibility for the outer slide that transitions offscreen

        function prev() {
          if (!translationComplete) return;

          translationComplete = false;
          index = index === 0 ? amount - 1 : index - 1;

          const outerIndex = index % amount;

          sliderItems.forEach((slide, i) => {
            slide.style.opacity = '1';
            slide.style.transform = `translateX(${(currTransl[i] += moveOffset)}px)`; // slider position update
          });

          const outerSlide = sliderItems[outerIndex];
          outerSlide.style.transform = `translateX(${(currTransl[outerIndex] -= moveOffset * amount)}px)`;
          outerSlide.style.opacity = '0';
        }

        function next() {
          if (!translationComplete) return;

          translationComplete = false;
          const outerIndex = index % amount;
          index++;

          sliderItems.forEach((slide, i) => {
            slide.style.opacity = '1';
            slide.style.transform = `translateX(${(currTransl[i] -= moveOffset)}px)`; // slider position update
          });

          const outerSlide = sliderItems[outerIndex];
          outerSlide.style.transform = `translateX(${(currTransl[outerIndex] += moveOffset * amount)}px)`;
          outerSlide.style.opacity = '0';
          setTimeout(() => {
            outerSlide.style.opacity = '1';
          }, 500);
        }

        document.getElementById('prev').addEventListener('click', prev, true);
        document.getElementById('next').addEventListener('click', next, true);

        slider.addEventListener('mousedown', dragStart);
        slider.addEventListener('mousemove', dragMove);
        slider.addEventListener('mouseup', dragEnd);
        slider.addEventListener('mouseleave', dragEnd);
      }
    }
  });

  observerGallery.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Function for adding an event handler to an element
function addHoverListenerOpacity(tag) {
  tag.addEventListener('mouseover', function () {
    const parentElement = tag.closest('.cevoid-tag-wrapper');
    if (parentElement.offsetTop > 270) {
      tag
        .closest('.cevoid-tag-wrapper')
        .querySelector('.cevoid-tag-inner div').style.marginTop = '-25px';
    }
    tag
      .closest('.cevoid-tag-wrapper')
      .querySelector('.cevoid-tag-inner div')
      .classList.add('active');
    tag
      .closest('.cevoid-tag-wrapper')
      .querySelector('.cevoid-tag-inner div').style.transition = '.5s ease';
    tag
      .closest('.cevoid-tag-wrapper')
      .querySelector('.cevoid-tag-inner div').style.pointerEvents = 'all';
  });
}
function addHoverListener(tag) {
  tag.addEventListener('mouseleave', function () {
    const parentElement = tag.closest('.cevoid-tag-wrapper');
    if (parentElement.offsetTop > 270) {
      tag
        .closest('.cevoid-tag-wrapper')
        .querySelector('.cevoid-tag-inner div').style.marginTop = '-25px';
    }
    setTimeout(() => {
      tag
        .closest('.cevoid-tag-wrapper')
        .querySelector('.cevoid-tag-inner div')
        .classList.remove('active');
      tag
        .closest('.cevoid-tag-wrapper')
        .querySelector('.cevoid-tag-inner div').style.transition = '.5s ease';
      tag
        .closest('.cevoid-tag-wrapper')
        .querySelector('.cevoid-tag-inner div').style.pointerEvents = 'all';
    }, 3000);
  });
}
// get all cevoid-tag a elements and remove attribute href
// Creating new MutationObserver
let observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type === 'childList') {
      let tags = document.querySelectorAll('.cevoid-tag');
      setTimeout(() => {
        tags.forEach(addHoverListenerOpacity);
        tags.forEach(addHoverListener);
      }, 600);
      const tagsLinks = document.querySelectorAll('.cevoid-tag a');
      tagsLinks.forEach(function (tag) {
        tag.removeAttribute('href');
      });
    }
  });
});

let config = { childList: true, subtree: true };
observer.observe(document.body, config);
